export const openLink = (link, newTab = true) => {
  if (!link) {
    return;
  }
  const target = newTab ? '_blank' : '_self';
  return window.open(link, target, 'noopener,noreferrer');
};
